import { createHeader, createSubHeader, createBulletPoint } from "./componentHelpers"

export const renderCourseworkSection = (courseworkExperiences) => {
  if (!courseworkExperiences || courseworkExperiences.length === 0) {
    return []
  }

  return [
    ...createHeader("COURSEWORK"),
    ...courseworkExperiences
      .filter((experience) => experience)
      .flatMap((experience) => {

        const title = experience.title || 'TITLE'
        const school = experience.school || 'SCHOOL'
        // const endDate = experience.endDate || 'DATE AWARDED'
        const bulletPoints = experience.bulletPoints || []

        return [
          createSubHeader(title, school, "", "", ""),
          bulletPoints.map(b => createBulletPoint(b)),
        ].flat()
      }),
  ]
}
